import { useContext } from 'react';
import { Medialink } from '../../../../../api/medialink';
import MedialinksContext from '../../_contexts/MedialinksContext';
import AssignmentSection from './AssignmentSection';
import MedialinkSections from './MedialinkSections';
import SharedMaterialSection from './SharedMaterialSection';
import MyAssignmentsContext from '../../../../../contexts/MyAssignmentsContext';
import ModuleContext from '../../../_contexts/ModuleContext';
import TableOfContentsContext from '../../_contexts/TableOfContentsContext';
import EmptyState from '../../../../../shared-components/EmptyState';
import { useTranslation } from 'react-i18next';
import Section from '@pelckmans/elementis/components/section';

const BASE = 'PAGES.TOC_LEVEL.SECTIONS.STUDENT';

function splitUpTeacherAndStudentMedialinks(medialinks: Medialink[]) {
  return medialinks.reduce(
    (acc: { teacherMedialinks: Medialink[]; studentMedialinks: Medialink[] }, medialink) => {
      if (medialink.group === 'teacher') {
        acc.teacherMedialinks.push(medialink);
      } else {
        acc.studentMedialinks.push(medialink);
      }
      return acc;
    },
    { teacherMedialinks: [], studentMedialinks: [] },
  );
}

export default function MaterialSections() {
  const { t } = useTranslation();
  const { selectedModule } = useContext(ModuleContext);
  const { selectedNode } = useContext(TableOfContentsContext);
  const { assignments } = useContext(MyAssignmentsContext);
  const { medialinks } = useContext(MedialinksContext);

  if (!selectedModule || !selectedNode) return null;

  const assignmentsByModule = assignments.filter(
    a => a.moduleId === selectedModule?.id && a.nodeId === selectedNode?.id,
  );
  const { teacherMedialinks, studentMedialinks } = splitUpTeacherAndStudentMedialinks(medialinks);

  const isEmpty = assignmentsByModule.length === 0 && teacherMedialinks.length === 0 && studentMedialinks.length === 0;

  if (isEmpty) {
    return (
      <Section title={t(`${BASE}.EMPTY_DIALOG.TITLE`)}>
        <EmptyState
          variant="list"
          headerTitle={t(`${BASE}.EMPTY_DIALOG.SUBTITLE`)}
          bodyText={t(`${BASE}.EMPTY_DIALOG.TEXT`)}
        />
      </Section>
    );
  }

  return (
    <div className="material-sections">
      <AssignmentSection assignments={assignmentsByModule} module={selectedModule} />
      <SharedMaterialSection medialinks={teacherMedialinks} />
      <MedialinkSections medialinks={studentMedialinks} />
    </div>
  );
}
